/**
 * App
 */

import $ from 'jquery';
import { Functions } from './helpers';
import Log from './helpers/log';

class App {
    constructor( app ) {
        App.Win = typeof window !== 'undefined' ? window : this;
        App.Doc = App.Win.document;
        App.Settings = app.config;
        App.Core = function() {
            this.lang = app.config.lang;
            // this.startID = startID;
            this.debugging = app.config.debugging;
            this.logged = app.config.logged;
            this.role = app.config.role;

            this.Version = '@version';
            this.Components = {};

            this.DontConflict = false;
            this.Conflicts = {
                fn: {},
            };

            this.ReadyHandlers = [];
            this.ResizeHandlers = [];
            this.ScrollHandlers = [];
            this.RAFHandlers = [];
            this.LoadHandlers = [];

            // Globals
            this.window = App.Win;
            this.$window = $( App.Win );
            this.document = App.Doc;
            this.$document = $( App.Doc );
            this.$body = null;

            // Flags
            this.initialized = false;
            this.doingScroll = false;
            this.doingResize = false;
            this.doingAjax = false;
            this.hasTouch = false;
            this.load = false;
            this.ready = false;
            this.hashChanged = false;
            this.viewportWidth = 0;
            this.viewportHeight = 0;
            this.viewportInitialHeight = 0;
            this.userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
            this.isFirefox = /Firefox/i.test( this.userAgent );
            this.isChrome = /Chrome/i.test( this.userAgent );
            this.isSafari = /Safari/i.test( this.userAgent ) && ! this.isChrome;
            this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( this.userAgent );
            this.isIEMobile = /IEMobile/i.test( this.userAgent );
            this.isFirefoxMobile = ( this.isFirefox && this.isMobile );
            this.transform = null;
            this.transition = null;
            this.affix = 0;
            this.mastheadStuck = 0;
            this.ResizeTimer = null;
            this.Debounce = 20;

            this.support = {
                file: !! ( window.File && window.FileList && window.FileReader ),
                history: !! ( window.history && window.history.pushState && window.history.replaceState ),
                matchMedia: !! ( window.matchMedia || window.msMatchMedia ),
                pointer: !! ( window.PointerEvent ),
                raf: !! ( window.requestAnimationFrame && window.cancelAnimationFrame ),
                touch: !! ( ( 'ontouchstart' in window ) || window.DocumentTouch && document instanceof window.DocumentTouch ),
                transition: false,
                transform: false,
            };
        };

        App.Frontend = new App.Core();

        // Deferred ready
        App.$Ready = $.Deferred();

        /**
         * Mount
         */
        App.mount( app.components );

        /**
         * Event Window
         *
         * @scroll
         * @resize
         * @load
         */
        App.Frontend.$window.on( 'scroll.pwn', () => {
            App.onWindowScroll();
        } ).on( 'resize.pwn', () => {
            App.onWindowResize();
        } ).on( 'load.pwn', () => {
            App.onWindowLoad();
        } );

        /**
         * Event Window@resize
         *
         * Debounce the resize event on init
         *
         * @resize
         */
        App.onWindowResize();

        /**
         * RAF
         */
        App.handleRAF();

        /**
         * Event Document
         *
         * @ready
         */
        $( () => {
            App.Frontend.$body = $( 'body' );

            App.$Ready.resolve();

            /**
             * On ready or what?
             */
            App.Frontend.ready = ! 0;
        } );

        window.Frontend = App.Frontend;
    }

    static mountComponent( instance, namespace, settings ) {
        App.Frontend.Components[ namespace ] = ( ( instance, namespace, settings ) => {
            // Locals
            settings.initialized = false;

            // Extend Methods
            settings.methods = $.extend( true, {
                _setup: $.noop, // Document ready
                _resize: null, // Window resize
                _scroll: null, // Window scroll
                _load: null, // Window load
                _raf: null, // Window load
            }, settings.methods );

            // Resize handler
            if ( settings.methods._resize ) {
                App.Frontend.ResizeHandlers.push( {
                    instance: instance,
                    namespace: namespace,
                    priority: settings.priority,
                    callback: settings.methods._resize,
                } );

                // Sort handlers on push
                App.Frontend.ResizeHandlers.sort( App.sortPriority );
            }

            // Scroll handler
            if ( settings.methods._scroll ) {
                App.Frontend.ScrollHandlers.push( {
                    instance: instance,
                    namespace: namespace,
                    priority: settings.priority,
                    callback: settings.methods._scroll,
                } );

                // Sort handlers on push
                App.Frontend.ScrollHandlers.sort( App.sortPriority );
            }

            // RAF handler
            if ( settings.methods._raf ) {
                App.Frontend.RAFHandlers.push( {
                    instance: instance,
                    namespace: namespace,
                    priority: settings.priority,
                    callback: settings.methods._raf,
                } );

                // Sort handlers on push
                App.Frontend.RAFHandlers.sort( App.sortPriority );
            }

            // Load handler
            if ( settings.methods._load ) {
                App.Frontend.LoadHandlers.push( {
                    instance: instance,
                    namespace: namespace,
                    priority: settings.priority,
                    callback: settings.methods._load,
                } );

                // Sort handlers on push
                App.Frontend.LoadHandlers.sort( App.sortPriority );
            }

            return settings;
        } )( instance, namespace, settings );

        // Setup, catches lazy-loaded components, ensures order
        App.$Ready.then( () => {
            App.setupComponent( namespace );
        } );

        return App.Frontend.Components[ namespace ];
    }

    /**
     * @method private
     * @name unmountComponentMethod
     * @description Unregister an method of a class programmatically.
     * @param instance [object] "Class instance"
     * @param namespace [string] "Class namespace"
     * @param methodToRemove [string] "Method of the class that should be removed"
     * @return [void]
     */
    /*static unmountComponentMethod( instance, namespace, methodToRemove ) {
        const instanceName = instance.constructor.name;

        if ( App.Frontend.Components[ namespace ].methods ) {
            const methods = App.Frontend.Components[ namespace ].methods;
            const handlers = [ App.Frontend.ResizeHandlers, App.Frontend.ScrollHandlers, App.Frontend.RAFHandlers ];

            handlers.forEach( function( handler, handler_index ) {
                for ( const method in methods ) {
                    for ( const i in handler ) {
                        if ( handler.hasOwnProperty( i ) ) {
                            const callbackName = handler[ i ].callback.name;

                            if (
                                handler[ i ].namespace === namespace &&
                                callbackName.indexOf( methodToRemove ) !== -1
                            ) {
                                handler[ i ].callback = $.noop;

                                Debug.debug( `${ instanceName }: successfully unregister method: ${ methodToRemove }`, 'event' );
                            }
                        }
                    }
                }
            } );
        }
    }*/

    /**
     * @method private
     * @name mountComponentMethod
     * @description Register an method of a class programmatically.
     * @param instance [object] "Class instance"
     * @param namespace [string] "Class namespace"
     * @param methodToAdd [string] "Method of the class that should be added"
     * @return [void]
     */
    // static mountComponentMethod( instance, namespace, methodToAdd ) {
        /**
         * todo: from time to time we need to unregister an method to prevent doing further jobs,
         * which unmountComponentMethod() already do, but what if we need to register it again when certain events happen?
         * This should be implemented.
         */

        // code ...
    // }

    static setupComponent( namespace ) {
        if ( ! App.Frontend.Components[ namespace ].initialized ) {
            App.Frontend.Components[ namespace ].methods._setup.call( document );
            App.Frontend.Components[ namespace ].initialized = true;
        }
    }

    static sortPriority( a, b ) {
        return ( parseInt( a.priority ) - parseInt( b.priority ) );
    }

    static onWindowScroll() {
        /**
         * Doing scroll or what?
         */
        App.Frontend.doingScroll = ! App.Frontend.doingScroll;

        for ( const i in App.Frontend.ScrollHandlers ) {
            if ( App.Frontend.ScrollHandlers.hasOwnProperty( i ) ) {
                App.Frontend.ScrollHandlers[ i ].callback.call( window, App.Frontend.viewportWidth, App.Frontend.viewportHeight );
            }
        }

        // Helpers.Debug.debug('scroll', 'event');
    }

    static onWindowResize() {
        App.Frontend.ResizeTimer = Functions.startTimer( App.Frontend.ResizeTimer, App.Frontend.Debounce, App.handleWindowResize );
    }

    static handleWindowResize() {
        if ( ! App.Frontend.support.raf ) {
            App.Frontend.viewportWidth = App.Frontend.$window.width();
            App.Frontend.viewportHeight = App.Frontend.$window.height();
        }

        for ( const i in App.Frontend.ResizeHandlers ) {
            if ( App.Frontend.ResizeHandlers.hasOwnProperty( i ) ) {
                App.Frontend.ResizeHandlers[ i ].callback.call( window, App.Frontend.viewportWidth, App.Frontend.viewportHeight );
            }
        }

        // Helpers.Debug.debug('resize','event');
    }

    static handleRAF() {
        if ( ! App.Frontend.support.raf ) {
            return;
        }

        App.Frontend.viewportWidth = App.Frontend.$window.width();
        App.Frontend.viewportHeight = App.Frontend.$window.height();

        App.Frontend.window.requestAnimationFrame( App.handleRAF );

        for ( const i in App.Frontend.RAFHandlers ) {
            if ( App.Frontend.RAFHandlers.hasOwnProperty( i ) ) {
                App.Frontend.RAFHandlers[ i ].callback.call( window );
            }
        }
    }

    static onWindowLoad() {
        /**
         * On load or what?
         */
        App.Frontend.load = true;

        for ( const i in App.Frontend.LoadHandlers ) {
            if ( App.Frontend.LoadHandlers.hasOwnProperty( i ) ) {
                App.Frontend.LoadHandlers[ i ].callback.call( window );
            }
        }

        // Helmountpers.Debug.debug('load', 'event');
    }

    /**
     * @param {array} components
     */
    static mount( components ) {
        $.each( components, ( index, Component ) => {
            const componentInstance = new Component( App );

            App.mountComponent( componentInstance, componentInstance.getNamespace(), componentInstance.settings );
        } );

        // Helpers.Debug.debug('setup', 'init');
    }
}

export default ( app ) => {
    return new App( app );
};
